import IconCopy from '../../../../../../components/icons/icon-copy/icon-copy';
import { ButtonIcon } from '../../../../../../components/inputs/button-icon/button-icon';

interface CopyApiKeyButtonProps {
    apiKey: string;
    isDisabled: boolean;
}

const CopyApiKeyButton: React.FC<CopyApiKeyButtonProps> = ({ apiKey, isDisabled }) => {
    const handleClick = () => {
        navigator.clipboard.writeText(apiKey);
    };

    return (
        <ButtonIcon Component={IconCopy} onClick={handleClick} disabled={isDisabled} />
    );
};

export default CopyApiKeyButton;
